import { useNavigate } from "react-router-dom";
import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import {
    setTokenHeader, getJwtFromCookies, basePort,
    getUsernameJwt, headers, isExpiredJwt, queryParameters, renderRedirect
} from "../../../module_auth/AuthService"
import { TalentCardMypage } from "./TalentCardMypage";

export function TalentListMypage() {
    const [objectList, setObjectList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");
    const [mbrId, setMbrId] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            //alert
            setRedirect(true)
        } else {
            setRedirect(false)
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))

            navigate("/talent_list_mypage");

            let url = basePort + '/get/talent/mypage'

            setTokenHeader(getJwtFromCookies())
            // GET 요청은 body를 포함하지 않습니다.
            fetch(url, {
                method: 'GET',
                headers
            })
                .then(response => {
                    if (!response.ok) throw new Error("데이터를 불러오지 못했습니다.");
                    return response.json();
                })
                .then(data => {
                    // 백엔드에서 List를 바로 보내므로 data 자체가 배열입니다.
                    setObjectList(data);
                    // 데이터 로드 성공 후 페이지 이동을 원하신다면 여기서 수행
                    // navigate("/talent_list_mypage");
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                });

        }

    }, []);

    function clickRegister() {
        let url = "/talent_reg_mypage"
        navigate(url);
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>마이페이지</span></li>
                            <li class="breadcrumb-item"><span>전문가등록정보</span></li>
                        </ol>
                        <div class="row" style={{ display: 'flex' }}>
                            <div class="col-md-6 d-md-flex justify-content-xxl-center">
                                <p class="d-flex justify-content-center justify-content-md-center align-items-xxl-center" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px', marginTop: '15px' }}>한인전문가</p>
                            </div>
                            <div class="col-md-6 d-flex d-md-flex justify-content-center justify-content-md-center align-items-md-center"><button class="btn btn-primary btn-sm text-end" type="button" onClick={clickRegister} style={{ borderRadius: '5px' }}>등록</button></div>
                        </div>
                        {/* end of container */}
                    </div>

                    <div className="container">
                        {/* row와 justify-content-center를 사용하여 중앙 정렬 및 폭 제한 */}
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-8 col-lg-8">
                                {objectList.map((object, index) => (
                                    <TalentCardMypage
                                        object={object}
                                        index={index}
                                        key={index}
                                        returnTo={"/talent_list_mypage"}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}